































/**
 * External dependencies.
 */
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

/**
 * Internal dependencies.
 */

@Component
export default class Input extends Vue {
  @Prop({ type: String, required: true }) name: string
  @Prop({ type: String, default: '' }) value: string
  @Prop({ type: String, default: '' }) label: string
  @Prop({ type: String, default: '' }) placeholder: string
  @Prop({ type: String, default: '' }) rules: string
  @Prop({ type: String, default: 'text' }) type: string
  @Prop({ type: String, default: '' }) prepend: string
  @Prop() error: string | null | boolean

  localValue: string = ''

  @Watch('value', { immediate: true })
  onValueChange (value: string) {
    this.localValue = value
  }
}
